module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-invisalign-tabs"
  }, [_c('div', {
    staticClass: "custom-invisalign-tabs__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-invisalign-tabs__tabs"
  }, _vm._l((_vm.props.tab_section), function(content, i) {
    return _c('div', {
      staticClass: "custom-invisalign-tabs__tab",
      class: {
        'custom-invisalign-tabs__tab--active': _vm.tab === i
      },
      domProps: {
        "innerHTML": _vm._s(content.title)
      },
      on: {
        "click": function($event) {
          return _vm.showTab(i)
        }
      }
    })
  }), 0), _vm._l((_vm.props.tab_section), function(content, i) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.tab === i),
        expression: "tab === i"
      }],
      staticClass: "custom-invisalign-tabs__tab--content"
    }, [_c('div', {
      staticClass: "custom-invisalign-tabs__container--accordion"
    }, _vm._l((content.content.accordion), function(item, i) {
      return _c('div', {
        staticClass: "custom-invisalign-tabs__accordion"
      }, [_c('div', {
        staticClass: "custom-invisalign-tabs__accordion--title",
        class: {
          'custom-invisalign-tabs__accordion--active': _vm.accordion === i
        },
        domProps: {
          "innerHTML": _vm._s(item.title)
        },
        on: {
          "click": function($event) {
            return _vm.showAccordion(i)
          }
        }
      }), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.accordion === i),
          expression: "accordion === i"
        }],
        staticClass: "custom-invisalign-tabs__accordion--body",
        domProps: {
          "innerHTML": _vm._s(item.body)
        }
      })])
    }), 0), _c('div', {
      staticClass: "custom-invisalign-tabs__container--image"
    }, [_c('div', {
      staticClass: "custom-invisalign-tabs__image",
      domProps: {
        "innerHTML": _vm._s(content.content.video)
      }
    })])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21512949","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-invisalign-tabs/custom-invisalign-tabs.pug
// module id = 632
// module chunks = 1